import { GeneralError } from '../Interfaces/ErrorInterfaces'
import { ReducerBuilder } from './ReducerBuilder'

type payloadType = GeneralError
type stateType = payloadType[]

const addError = (state: stateType, payload: payloadType) => [...state, payload]

const removeError = (state: stateType, payload: payloadType) => {
  const index = state.findIndex((error) => JSON.stringify(error) === JSON.stringify(payload))
  return index >= 0 ? [...state.slice(0, index), ...state.slice(index + 1)] : state
}

const removeGeneralErrorWithKey = (state: stateType, payload: string) => {
  return state.filter((error) => error.key !== payload)
}

const reducer = ReducerBuilder.create<stateType, payloadType | string>([])
  .mapAction('ERROR_ADD', addError)
  .mapAction('ERROR_REMOVE', removeError)
  .mapAction('ERROR_REMOVE_WITH_KEY', removeGeneralErrorWithKey)
  .build()

export default reducer
